import { render } from "./CmsText.vue?vue&type=template&id=e1bdf844"
import script from "./CmsText.vue?vue&type=script&lang=js"
export * from "./CmsText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__